export default ({ ariaLabelledby = '', square = false, checked = false, toggleCheckBox }) => {
    return (
        <div role="checkbox" aria-checked={checked} aria-labelledby={ariaLabelledby} className={`checkbox-round ${square ? 'checkbox-square' : ''}`} onClick={toggleCheckBox}>
            <input type="checkbox" checked={checked} onChange={() => {}} />
            <label for="checkbox"></label>
        </div>
    )
}
